<template>
  <div class="wrap" :style="{ minHeight: fullScreen ? '' : 0 }">
    <div class="tabs fixed" v-if="tabs">
      <div class="tabs_wrap flex around bg-fff" :style="{
        borderTop: tabTopBorder ? '' : 0,
        borderBottom: tabBottomBorder ? '' : 0,
        '--active': active || '',
        '--inActive': inActive || '',
      }">
        <div class="tab_item flex flex-center relative" v-for="(item, index) in tabs" :key="index"
          @click="tabChange(item)">
          <div :style="{
            color: tabVal
              ? tabNow === item[tabVal]
                ? 'var(--active)'
                : 'var(--inActive)'
              : tabKey
                ? tabNow === item[tabKey]
                  ? 'var(--active)'
                  : 'var(--inActive)'
                : tabNow === item
                  ? 'var(--active)'
                  : 'var(--inActive)',
          }" v-if="item">
            {{ tabKey ? item[tabKey] : item }}
          </div>
          <div class="absolute line" v-if="item" :style="{
            backgroundColor: tabVal
              ? tabNow === item[tabVal]
                ? 'var(--active)'
                : ''
              : tabKey
                ? tabNow === item[tabKey]
                  ? 'var(--active)'
                  : ''
                : tabNow === item
                  ? 'var(--active)'
                  : '',
          }"></div>
        </div>
      </div>
    </div>
    <div class="placeholder" v-if="tabs && tabFixed"></div>
    <div class="list" v-if="list">
      <van-pull-refresh v-model="refreshing" :disabled="!pullRefresh" @refresh="handleRefresh"
        :pulling-text="$t('pullRefresh.pulling')" :loosing-text="$t('pullRefresh.pulling')"
        :loading-text="$t('pullRefresh.loading')" :success-text="$t('pullRefresh.success')">
        <van-list @load="nextPage" v-model="loading" :finished="finish"
          :finished-text="listData.length ? $t('Hint.notMore') : ''" :loading-text="$t('Hint.loading')"
          :immediate-check="false" :error.sync="error" :error-text="$t('listStatus.error')">
          <div v-for="(item, index) in listData" :key="index">
            <div class="padding0-12 top18" v-if="listData && listData.length && !customList">
              <div class="radius10 bg-fff">
                <slot name="listItem" :data="item"></slot>
                <slot :name="tabNow" :data="item"></slot>
              </div>
            </div>
            <!--  -->
            <div v-if="listData && listData.length && customList">
              <slot name="listItem" :data="item"></slot>
              <slot :name="tabNow" :data="item"></slot>
            </div>
          </div>
          <div class="nomore" v-if="finish && listData.length">
            <!-- <u-loadmore status="nomore" :nomoreText="$t('noMore')" /> -->
            <!-- {{ $t("noMore") }} -->
          </div>
          <div class="nodata" v-if="finish && !listData.length">
            <slot name="null">
              <van-image :src="nullImg || verConfig.nullPng || noDataBack" fit="contain" />
            </slot>
          </div>
        </van-list>
      </van-pull-refresh>
    </div>
  </div>
</template>

<script>
import noDataBack from "@/assets/Img/null/null.png";
import { List, Toast, Image, PullRefresh } from "vant";
export default {
  components: {
    [List.name]: List,
    [Image.name]: Image,
    [PullRefresh.name]: PullRefresh,
  },
  props: {
    url: {
      type: String,
    },
    fullScreen: {
      type: Boolean,
      default: true,
    },
    tabFixed: {
      type: Boolean,
      default: true,
    },
    //   tab的属性
    tabs: {
      type: Array,
    },
    tabKey: {
      type: String,
    },
    tabVal: {
      type: String,
    },
    active: {
      type: String,
    },
    inActive: {
      type: String,
    },
    tabTopBorder: {
      type: Boolean,
      default: true,
    },
    tabBottomBorder: {
      type: Boolean,
    },
    paramKey: {
      type: String,
      default: "",
    },
    initParamData: {
      type: Object,
    },
    // list的属性
    list: {
      type: Boolean,
    },
    perPage: {
      type: Number,
      default: 8,
    },
    request: {
      type: Boolean,
      default: true,
    },
    customList: {
      type: Boolean,
    },
    pullRefresh: {
      type: Boolean,
      default: false,
    },
    refresh: {
      type: Number,
      default: 0,
    },
    dataKey: {
      type: String,
      default: "lists",
    },
    nullImg: {
      type: String,
      default: "",
    },
  },
  data() {
    this.noDataBack = noDataBack;
    return {
      tabNow: "",
      listData: [],
      currentPage: 1,
      params: {},
      finish: false,
      loading: false,
      requesting: false,
      refreshing: false,
      error: false,
      firstGetList: true,
      requestVersion: 0,
    };
  },
  created() {
    this.tabNowInit();
    if (this.request) {
      this.getList();
    } else this.finish = true;
  },
  beforeDestroy() {
    this.requestVersion += 1;
  },
  methods: {
    tabChange(item) {
      const nextTab = this.tabVal ? item[this.tabVal] : this.tabKey ? item[this.tabKey] : item;
      if (nextTab === this.tabNow) return;
      this.tabNow = nextTab;
      this.listData = [];
      this.$emit("tabChange", item);
      return this.handleRefresh();
    },
    tabNowInit() {
      if (this.tabs && this.tabs.length) {
        if (this.tabVal) {
          this.tabNow = this.tabs[0][this.tabVal];
        } else if (this.tabKey) {
          this.tabNow = this.tabs[0][this.tabKey];
        } else {
          this.tabNow = this.tabs[0];
        }
      }
    },
    nextPage() {
      if (this.requesting || this.finish || !this.request) return;
      if (!this.firstGetList) this.currentPage += 1;
      return this.getList();
    },
    initParams() {
      this.params = {
        ...this.params,
        ...this.initParamData,
        perPage: this.perPage,
        page: this.currentPage,
      };
      if (this.paramKey) this.params[this.paramKey] = this.tabNow;
    },
    handleRefresh(params = {}) {
      this.requestVersion += 1;
      this.currentPage = 1;
      this.firstGetList = true;
      this.finish = !this.request;
      this.error = false;
      this.loading = false;
      this.requesting = false;
      this.refreshing = this.request;
      this.params = { ...this.params, ...params };
      if (this.request) return this.getList();
    },
    async getList(success) {
      if (!this.request) {
        this.finish = true;
        return;
      }
      if (this.requesting) return;
      const version = this.requestVersion;
      const page = this.currentPage;
      this.loading = true;
      this.requesting = true;
      this.error = false;
      this.initParams();
      try {
        const data = await this.$api.getListCom(
          this.url,
          { ...this.params }
        );
        if (version !== this.requestVersion || this._isDestroyed) return;
        const lists = Array.isArray(data[this.dataKey]) ? data[this.dataKey] : [];
        this.listData = page === 1 ? lists : [...this.listData, ...lists];
        this.firstGetList = false;
        if (!lists.length) {
          this.finish = true;
        } else if (data.hasMorePages != null) {
          this.finish = ![true, 1, '1', 'true'].includes(data.hasMorePages);
        } else if (data.lastPage != null) {
          this.finish = page >= Number(data.lastPage);
        } else {
          this.finish = lists.length < this.perPage;
        }
        if (success) success({ lists });
      } catch (error) {
        if (version !== this.requestVersion || this._isDestroyed) return;
        this.error = true;
        this.currentPage = Math.max(1, page - 1);
        Toast((error && (error.msg || error.message)) || (typeof error === 'string' && error) || this.$t('Hint.failed'));
      } finally {
        if (version === this.requestVersion && !this._isDestroyed) {
          this.loading = false;
          this.requesting = false;
          this.refreshing = false;
        }
      }
    },
  },
  watch: {
    tabs() {
      this.tabNowInit();
    },
    refresh(val) {
      if (val) this.handleRefresh();
    },
  },
};
</script>

<style lang="less" scoped>
@import url("./common.css");

.wrap {
  background-color: var(--bg);
  min-height: calc(100vh - calc(44rem / 32));
}

.tabs {
  --active: var(--theme);
  --inActive: #707080;
  width: 100vw;
  z-index: 8;
}

.placeholder {
  width: 100vw;
  height: calc(61rem / 32);
}

.tabs_wrap {
  border-top: 1px solid var(--bg);
  border-bottom: 1px solid var(--bg);
}

.tab_item {
  height: calc(61rem / 32);
  background-color: #fff;
  font-size: calc(24rem / 32);
}

.line {
  height: calc(4rem / 32);
  width: calc(80rem / 32);
  bottom: 0;
  border-radius: calc(99rem / 32);
}

.nomore {
  color: #707080;
  height: calc(60rem / 32);
  display: flex;
  align-items: center;
  justify-content: center;
}

.nodata {
  display: flex;
  flex-direction: column;
  align-items: center;
  height: calc(100vh - calc(44rem / 32));
  background-color: #fff;

  /deep/ .van-image {
    width: 80%;
    aspect-ratio: 1 / 1;
    padding: 20px 0;
  }
}
</style>
